import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pt-11 pt-md-9 pb-0 position-relative" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex flex-wrap align-items-center break-all mb-2" }
const _hoisted_8 = { class: "text-gray-900 fs-2 fw-bolder text-uppercase" }
const _hoisted_9 = { class: "text-gray-900 fs-2 fw-bold" }
const _hoisted_10 = {
  key: 0,
  class: "text-gray-900 fs-2 fw-light"
}
const _hoisted_11 = { class: "d-flex align-items-center flex-wrap text-gray-400 fw-semibold fs-6 mb-4 pe-2" }
const _hoisted_12 = { class: "svg-icon svg-icon-4 ms-1" }
const _hoisted_13 = {
  key: 0,
  class: "text-gray-900 fw-bolder mx-1"
}
const _hoisted_14 = {
  key: 1,
  class: "text-gray-900 fw-bolder mx-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-900 fw-bolder" }, ",", -1)
const _hoisted_16 = { class: "mx-1" }
const _hoisted_17 = { class: "text-gray-900 fw-bolder" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex mb-2"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_21 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_22 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_25 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_26 = {
  key: 0,
  class: "ms-2"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3",
  "data-kt-menu": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "menu-content text-muted pb-2 px-3 fs-7 text-uppercase" }, " Payments ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "menu-link px-3"
    }, "Create Invoice")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "menu-link flex-stack px-3"
    }, [
      /*#__PURE__*/_createTextVNode("Create Payment "),
      /*#__PURE__*/_createElementVNode("i", {
        class: "fas fa-exclamation-circle ms-2 fs-7",
        "data-bs-toggle": "tooltip",
        "aria-label": "Specify a target name for future usage and reference",
        "data-bs-original-title": "Specify a target name for future usage and reference",
        "data-kt-initialized": "1"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "menu-link px-3"
    }, "Generate Bill")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "menu-item px-3",
    "data-kt-menu-trigger": "hover",
    "data-kt-menu-placement": "right-end"
  }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "menu-link px-3"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Subscription"),
      /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "menu-sub menu-sub-dropdown w-175px py-4" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "menu-link px-3"
        }, "Plans")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "menu-link px-3"
        }, "Billing")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "#",
          class: "menu-link px-3"
        }, "Statements")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }),
      /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "menu-content px-3" }, [
          /*#__PURE__*/_createElementVNode("label", { class: "form-check form-switch form-check-custom form-check-solid" }, [
            /*#__PURE__*/_createElementVNode("input", {
              class: "form-check-input w-30px h-20px",
              type: "checkbox",
              value: "1",
              checked: "checked",
              name: "notifications"
            }),
            /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-muted fs-6" }, "Recuring")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3 my-1" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "menu-link px-3"
    }, "Settings")
  ])
], -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "d-flex flex-column gap-3 flex-wrap mb-3" }
const _hoisted_31 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_32 = { class: "fs-4 fw-bold" }
const _hoisted_33 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_34 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_35 = { class: "fs-4 fw-bold" }
const _hoisted_36 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_37 = {
  key: 2,
  class: "d-flex flex-column"
}
const _hoisted_38 = { class: "fs-4 fw-bold" }
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_41 = {
  key: 3,
  class: "d-flex flex-column"
}
const _hoisted_42 = { class: "d-flex align-items-center position-relative pe-6" }
const _hoisted_43 = { class: "fs-4 fw-bold" }
const _hoisted_44 = { class: "fw-bolder text-dark" }
const _hoisted_45 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_46 = { class: "d-flex flex-column" }
const _hoisted_47 = { class: "d-flex align-items-center position-relative pe-6" }
const _hoisted_48 = { class: "fs-4 fw-bold" }
const _hoisted_49 = { class: "fw-bolder text-dark" }
const _hoisted_50 = { class: "fw-normal fs-6" }
const _hoisted_51 = ["title"]
const _hoisted_52 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_53 = {
  key: 4,
  class: "d-flex flex-column"
}
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = { class: "fs-4 fw-bold mw-200px text-line-clamp-1 break-all" }
const _hoisted_56 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_57 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_58 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_59 = { class: "d-flex flex-wrap" }
const _hoisted_60 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_61 = { class: "d-flex align-items-center" }
const _hoisted_62 = { class: "fs-4 fw-bold" }
const _hoisted_63 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_64 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_65 = { class: "d-flex align-items-center" }
const _hoisted_66 = { class: "fs-4 fw-bold" }
const _hoisted_67 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_68 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_69 = { class: "d-flex align-items-center position-relative pe-6" }
const _hoisted_70 = { class: "fs-4 fw-bold" }
const _hoisted_71 = ["title"]
const _hoisted_72 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_73 = {
  key: 3,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_74 = { class: "d-flex align-items-center" }
const _hoisted_75 = { class: "fs-4 fw-bold mw-200px text-line-clamp-1 break-all" }
const _hoisted_76 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_77 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_78 = { class: "d-flex align-items-center position-relative pe-6" }
const _hoisted_79 = { class: "fs-4 fw-bold" }
const _hoisted_80 = { class: "fw-bolder text-dark" }
const _hoisted_81 = { class: "fw-normal fs-6" }
const _hoisted_82 = ["title"]
const _hoisted_83 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_84 = {
  key: 4,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_85 = { class: "d-flex align-items-center" }
const _hoisted_86 = { class: "fs-4 fw-bold mw-200px text-line-clamp-1 break-all" }
const _hoisted_87 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_88 = {
  key: 0,
  class: "d-flex align-items-center w-200px w-sm-300px flex-column mt-3"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between fw-bolder w-100 mt-auto mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6 text-gray-400" }, "Next Step"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs-6" }, "Shipping on 05.10")
], -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "h-5px mx-3 w-100 bg-light mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "bg-success rounded h-5px",
    role: "progressbar",
    style: {"width":"50%"},
    "aria-valuenow": "50",
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  })
], -1)
const _hoisted_91 = [
  _hoisted_89,
  _hoisted_90
]
const _hoisted_92 = { class: "d-flex overflow-auto h-55px max-sm-scrollbar-hidden" }
const _hoisted_93 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_94 = { class: "nav-item" }
const _hoisted_95 = { class: "nav-item" }
const _hoisted_96 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t("common.salesOrder")) + " ", 1),
                  _createElementVNode("span", _hoisted_9, "#" + _toDisplayString(_ctx.SalesOrderOverviewData.sales_order_identifier.order_number), 1),
                  (
                    _ctx.SalesOrderOverviewData.sales_order_identifier
                      .order_number &&
                    !_ctx.isDoubleSale &&
                    !_ctx.isAuditView
                  )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, " / #" + _toDisplayString(_ctx.SalesOrderOverviewData.sales_order.encrypt_order_number), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_window_resize, null, {
                    sm: _withCtx(() => [
                      (
                        _ctx.SalesOrderOverviewData.sales_order_identifier.status
                      )
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["badge position-absolute start-0 top-0", 
                        _ctx.orderStatus(
                          _ctx.SalesOrderOverviewData.sales_order_identifier.status
                        )
                      ])
                          }, _toDisplayString(_ctx.SalesOrderOverviewData.__show.status), 3))
                        : _createCommentVNode("", true)
                    ]),
                    lg: _withCtx(() => [
                      (
                        _ctx.SalesOrderOverviewData.sales_order_identifier.status
                      )
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(["badge ms-2", 
                        _ctx.orderStatus(
                          _ctx.SalesOrderOverviewData.sales_order_identifier.status
                        )
                      ])
                          }, _toDisplayString(_ctx.SalesOrderOverviewData.__show.status), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.customer")), 1),
                    _createElementVNode("span", _hoisted_12, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com006.svg" })
                    ]),
                    (_ctx.isAuditView)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.getPinyinName), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.SalesOrderOverviewData.sales_order_account_information
                        .user_account_name), 1)),
                    (
                      _ctx.SalesOrderOverviewData.sales_order_extended_distribution
                        .external_order_number
                    )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _hoisted_15,
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t("salesOrderOverview.withExternalOrderNo")), 1),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.SalesOrderOverviewData.sales_order_extended_distribution
                        .external_order_number), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode(_component_window_resize, null, {
                sm: _withCtx(() => [
                  (!_ctx.isAuditView)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                          default: _withCtx(() => [
                            (
                        _ctx.SalesOrderOverviewData.sales_order_identifier.status >=
                          _ctx.SalesOrderNewStatus.Verified &&
                        _ctx.SalesOrderOverviewData.sales_order_identifier.status <
                          _ctx.SalesOrderNewStatus.Canceled
                      )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-sm btn-primary",
                                  disabled: _ctx.disabledExportOrderNotice || _ctx.loading,
                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fileExportOrderNotice && _ctx.fileExportOrderNotice(...args)))
                                }, [
                                  (_ctx.disabledExportOrderNotice || _ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr044.svg" })
                                      ])),
                                  _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrderOverview.orderNotice")), 1)
                                ], 8, _hoisted_19))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                lg: _withCtx(() => [
                  (!_ctx.isAuditView)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                          default: _withCtx(() => [
                            (
                        _ctx.SalesOrderOverviewData.sales_order_identifier.status >=
                          _ctx.SalesOrderNewStatus.Verified &&
                        _ctx.SalesOrderOverviewData.sales_order_identifier.status <
                          _ctx.SalesOrderNewStatus.Canceled
                      )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-sm btn-primary",
                                  disabled: _ctx.disabledExportOrderNotice || _ctx.loading,
                                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fileExportOrderNotice && _ctx.fileExportOrderNotice(...args)))
                                }, [
                                  (_ctx.disabledExportOrderNotice || _ctx.loading)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr044.svg" })
                                      ])),
                                  _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrderOverview.orderNotice")), 1)
                                ], 8, _hoisted_23))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_window_resize, null, {
              sm: _withCtx(() => [
                _createElementVNode("div", _hoisted_30, [
                  (
                    _ctx.SalesOrderOverviewData.sales_order_identifier.order_date &&
                    !_ctx.isDoubleSale
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.customFormatDate(
                        _ctx.SalesOrderOverviewData.sales_order_identifier.order_date
                      )), 1),
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.t("salesOrderOverview.orderDate")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (
                    _ctx.SalesOrderOverviewData.sales_order.show_order_date &&
                    _ctx.isDoubleSale
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.SalesOrderOverviewData.sales_order.show_order_date), 1),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.t("salesOrderOverview.orderDate")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (
                    _ctx.SalesOrderOverviewData.sales_order.standard_delivery_date &&
                    !_ctx.isDoubleSale &&
                    !_ctx.isAuditView
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.customFormatDate(
                        _ctx.SalesOrderOverviewData.sales_order
                          .standard_delivery_date
                      )), 1),
                          (
                        _ctx.SalesOrderOverviewData
                          .sales_order_extended_priority_management
                          .priority_level
                      )
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["position-absolute top-50 end-0 translate-middle-y svg-icon svg-icon-3", 
                        _ctx.getSalesOrderPriorityLevelSvgStyleMap(
                          _ctx.SalesOrderOverviewData
                            .sales_order_extended_priority_management
                            .priority_level
                        )
                      ]),
                                title: 
                        _ctx.SalesOrderOverviewData
                          .sales_order_extended_priority_management.__show
                          .priority_level
                      
                              }, [
                                _createVNode(_component_inline_svg_icon, {
                                  src: 
                          _ctx.getSalesOrderPriorityLevelMap(
                            _ctx.SalesOrderOverviewData
                              .sales_order_extended_priority_management
                              .priority_level
                          )
                        
                                }, null, 8, ["src"])
                              ], 10, _hoisted_39))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.SalesOrderOverviewData.sales_order_identifier.status >=
                      _ctx.SalesOrderNewStatus.Verified
                        ? _ctx.t("salesOrderOverview.delieveryDate")
                        : _ctx.t("salesOrderOverview.delieveryDateV2")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.SalesOrderOverviewData.sales_order.owner_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.getOwnerLabel(
                            _ctx.SalesOrderOverviewData.sales_order.owner_id
                          )), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("salesOrderOverview.operatingEntity")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("span", _hoisted_49, [
                          _createTextVNode(_toDisplayString(_ctx.SalesOrderOverviewData.base_currency_code == "￥"
                            ? _ctx.$currency.currency(
                                parseInt(
                                  _ctx.SalesOrderOverviewData.order_totals
                                    .base_grand_total_gross
                                ) || 0,
                                0,
                                ".",
                                "",
                                _ctx.SalesOrderOverviewData.base_currency_code
                              )
                            : _ctx.$currency.currency(
                                parseInt(
                                  _ctx.SalesOrderOverviewData.order_totals
                                    .base_grand_total_gross
                                ) || 0,
                                0,
                                ",",
                                ".",
                                _ctx.SalesOrderOverviewData.base_currency_code
                              )), 1),
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.getOrderTotals(
                            _ctx.SalesOrderOverviewData.order_totals
                              .base_grand_total_gross
                          )), 1)
                        ]),
                        (
                          _ctx.SalesOrderOverviewData
                            .sales_order_extended_distribution
                            .distribution_model
                        )
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "svg-icon svg-icon-3 me-0 ms-2",
                              title: 
                          _ctx.SalesOrderOverviewData
                            .sales_order_extended_distribution.__show
                            .distribution_model
                        
                            }, [
                              (
                            _ctx.SalesOrderOverviewData
                              .sales_order_extended_distribution
                              .distribution_model ==
                            String(_ctx.SalesOrderDistributionMode.GrossProfitMode)
                          )
                                ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                    key: 0,
                                    src: "media/svg/custom/gross-profit.svg"
                                  }))
                                : (
                            _ctx.SalesOrderOverviewData
                              .sales_order_extended_distribution
                              .distribution_model ==
                            String(_ctx.SalesOrderDistributionMode.GMVMode)
                          )
                                  ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                      key: 1,
                                      src: "media/icons/duotune/ecommerce/ecm003.svg"
                                    }))
                                  : _createCommentVNode("", true)
                            ], 8, _hoisted_51))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.t("order.skuPcs", [
                        _ctx.SalesOrderOverviewData.ordered_items.length,
                        _ctx.SalesOrderOverviewData.sales_order.total_qty_ordered,
                      ])), 1)
                  ]),
                  (_ctx.SalesOrderOverviewData.sales_order.brand.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.CommonArrayToString(
                          _ctx.SalesOrderOverviewData.sales_order.brand
                        )), 1)
                        ]),
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.t("salesOrderOverview.brands", [
                        _ctx.SalesOrderOverviewData.sales_order.brand.length,
                      ])), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              lg: _withCtx(() => [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      (
                        _ctx.SalesOrderOverviewData.sales_order_identifier
                          .order_date && !_ctx.isDoubleSale
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.customFormatDate(
                              _ctx.SalesOrderOverviewData.sales_order_identifier
                                .order_date
                            )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.t("salesOrderOverview.orderDate")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                        _ctx.SalesOrderOverviewData.sales_order.show_order_date &&
                        _ctx.isDoubleSale
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.SalesOrderOverviewData.sales_order.show_order_date), 1)
                            ]),
                            _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.t("salesOrderOverview.orderDate")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                        _ctx.SalesOrderOverviewData.sales_order
                          .standard_delivery_date &&
                        !_ctx.isDoubleSale &&
                        !_ctx.isAuditView
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.customFormatDate(
                              _ctx.SalesOrderOverviewData.sales_order
                                .standard_delivery_date
                            )), 1),
                                (
                              _ctx.SalesOrderOverviewData
                                .sales_order_extended_priority_management
                                .priority_level
                            )
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["position-absolute top-50 end-0 translate-middle-y svg-icon svg-icon-3", 
                              _ctx.getSalesOrderPriorityLevelSvgStyleMap(
                                _ctx.SalesOrderOverviewData
                                  .sales_order_extended_priority_management
                                  .priority_level
                              )
                            ]),
                                      title: 
                              _ctx.SalesOrderOverviewData
                                .sales_order_extended_priority_management.__show
                                .priority_level
                            
                                    }, [
                                      _createVNode(_component_inline_svg_icon, {
                                        src: 
                                _ctx.getSalesOrderPriorityLevelMap(
                                  _ctx.SalesOrderOverviewData
                                    .sales_order_extended_priority_management
                                    .priority_level
                                )
                              
                                      }, null, 8, ["src"])
                                    ], 10, _hoisted_71))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.SalesOrderOverviewData.sales_order_identifier
                            .status >= _ctx.SalesOrderNewStatus.Verified
                            ? _ctx.t("salesOrderOverview.delieveryDate")
                            : _ctx.t("salesOrderOverview.delieveryDateV2")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.SalesOrderOverviewData.sales_order.owner_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.getOwnerLabel(
                              _ctx.SalesOrderOverviewData.sales_order.owner_id
                            )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.$t("salesOrderOverview.operatingEntity")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("span", _hoisted_80, [
                              _createTextVNode(_toDisplayString(_ctx.SalesOrderOverviewData.base_currency_code == "￥"
                                ? _ctx.$currency.currency(
                                    parseInt(
                                      _ctx.SalesOrderOverviewData.order_totals
                                        .base_grand_total_gross
                                    ) || 0,
                                    0,
                                    ".",
                                    "",
                                    _ctx.SalesOrderOverviewData.base_currency_code
                                  )
                                : _ctx.$currency.currency(
                                    parseInt(
                                      _ctx.SalesOrderOverviewData.order_totals
                                        .base_grand_total_gross
                                    ) || 0,
                                    0,
                                    ",",
                                    ".",
                                    _ctx.SalesOrderOverviewData.base_currency_code
                                  )), 1),
                              _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.getOrderTotals(
                                _ctx.SalesOrderOverviewData.order_totals
                                  .base_grand_total_gross
                              )), 1)
                            ]),
                            (
                              _ctx.SalesOrderOverviewData
                                .sales_order_extended_distribution
                                .distribution_model
                            )
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "position-absolute top-50 end-0 translate-middle-y svg-icon svg-icon-3",
                                  title: 
                              _ctx.SalesOrderOverviewData
                                .sales_order_extended_distribution.__show
                                .distribution_model
                            
                                }, [
                                  (
                                _ctx.SalesOrderOverviewData
                                  .sales_order_extended_distribution
                                  .distribution_model ==
                                String(
                                  _ctx.SalesOrderDistributionMode.GrossProfitMode
                                )
                              )
                                    ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                        key: 0,
                                        src: "media/svg/custom/gross-profit.svg"
                                      }))
                                    : (
                                _ctx.SalesOrderOverviewData
                                  .sales_order_extended_distribution
                                  .distribution_model ==
                                String(_ctx.SalesOrderDistributionMode.GMVMode)
                              )
                                      ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                          key: 1,
                                          src: "media/icons/duotune/ecommerce/ecm003.svg"
                                        }))
                                      : _createCommentVNode("", true)
                                ], 8, _hoisted_82))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.t("order.skuPcs", [
                            _ctx.SalesOrderOverviewData.ordered_items.length,
                            _ctx.SalesOrderOverviewData.sales_order
                              .total_qty_ordered,
                          ])), 1)
                      ]),
                      (_ctx.SalesOrderOverviewData.sales_order.brand.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                            _createElementVNode("div", _hoisted_85, [
                              _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.CommonArrayToString(
                              _ctx.SalesOrderOverviewData.sales_order.brand
                            )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.t("salesOrderOverview.brands", [
                            _ctx.SalesOrderOverviewData.sales_order.brand.length,
                          ])), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, _hoisted_91))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_92, [
          _createElementVNode("ul", _hoisted_93, [
            _createElementVNode("li", _hoisted_94, [
              _createVNode(_component_router_link, {
                to: _ctx.getStoreRouter + _ctx.$route.params.id + '/overview',
                replace: "",
                class: "nav-link text-active-primary ms-0 me-10 py-5",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("salesOrder.overview")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_95, [
              _createVNode(_component_router_link, {
                to: _ctx.getStoreRouter + _ctx.$route.params.id + '/sales-profilling',
                replace: "",
                class: "nav-link text-active-primary ms-0 me-10 py-5",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("salesOrder.requirement")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_96, [
              _createVNode(_component_router_link, {
                to: _ctx.getStoreRouter + _ctx.$route.params.id + '/order-tracking',
                replace: "",
                class: "nav-link text-active-primary ms-0 me-10 py-5",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("salesOrderOverview.tracking")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view, {
      onGetFormData: _ctx.getFormInfo,
      loading: _ctx.loading,
      userAccount: _ctx.userAccount,
      detailData: _ctx.SalesOrderOverviewData
    }, null, 8, ["onGetFormData", "loading", "userAccount", "detailData"])
  ], 64))
}